import { render, staticRenderFns } from "./ParamsNameWithCodeHeader.vue?vue&type=template&id=da5cdd58&scoped=true"
import script from "./ParamsNameWithCodeHeader.vue?vue&type=script&lang=js"
export * from "./ParamsNameWithCodeHeader.vue?vue&type=script&lang=js"
import style0 from "./ParamsNameWithCodeHeader.vue?vue&type=style&index=0&id=da5cdd58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da5cdd58",
  null
  
)

export default component.exports